import { useEffect, useRef } from 'react'
import { trackEvent } from '~/shared/lib/analytics'
import { DOCUMENT_PDF_DEPTH_MILESTONE } from '../config'
import { useStepSession } from './step-session-context'

const MILESTONES = [25, 50, 75, 100] as const

export function useReadingDepth(currentPage: number, totalPages: number) {
  const { step, documentKey } = useStepSession()
  const firedRef = useRef<Set<number>>(new Set())

  // Reset fired milestones when step/document changes
  useEffect(() => {
    firedRef.current = new Set()
  }, [step, documentKey])

  useEffect(() => {
    if (totalPages <= 0 || currentPage <= 0) return

    const percentage = (currentPage / totalPages) * 100

    for (const milestone of MILESTONES) {
      if (percentage >= milestone && !firedRef.current.has(milestone)) {
        firedRef.current.add(milestone)
        trackEvent(DOCUMENT_PDF_DEPTH_MILESTONE, {
          step,
          document_key: documentKey,
          milestone,
        })
      }
    }
  }, [currentPage, totalPages, step, documentKey])
}
